<div class="twofactor-wrapper">
  <div class="column__figure">
    <h2>
      Multi-Factor <br />
      Authentication
    </h2>
    <div class="figure__icon"><img src="assets/styles/portal/build/assets/images/multifactor.svg" alt="Manage Your Account" /></div>
    <p>Manage Your Account</p>
  </div>
  <div class="column__content">
    <img src="assets/styles/portal/build/assets/images/reflecx-logo.svg" class="tf-logo" alt="Reflecx" />
    <h3>Manage your account</h3>
    <h1>Recovery Code</h1>
    <div class="yellow-highlight">
      <img class="icon" src="assets/styles/portal/build/assets/images/icon-info.svg" alt="" />
      <p><strong>Put this code in safe place.</strong></p>
      <p>If you lose your device and don't have the recovery codes you will lose access to your account.</p>
    </div>
    <div class="tf-recovery-code-holder">
      <p><span class="tf-red-highlight">{{code}}</span></p>
    </div>

    <button (click)="onContinue()" class="tf-error-btn">Continue</button>
  </div>
</div>
